export const imageUrls = [
  "https://miro.medium.com/max/1400/1*nYhOZSDoERMKXe5SrhoObA.png",
];
export const titles = ["Setup Arduino IDE to flash a project to ESP32"];
export const hashTags = ["#ESP32, #Arduino"];
export const redirectUrls = [
  "https://medium.com/@pauljoegeorge/setup-arduino-ide-to-flash-a-project-to-esp32-34db014a7e65",
];
